import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { Rect, Defs, Mask } from 'react-native-svg';
import { rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import WalkthroughBubbleArrow, { BUBBLE_ARROW_WIDTH, } from '../WalkthroughBubbleArrow';
import NotificationsWalkthroughBubbleContent from './NotificationsWalkthroughBubbleContent';
import { isWeb, isAndroid } from '../../../../../constants';
const NotificationsWalkthrough = ({ notificationPosition, onDismiss, }) => {
    const { paddingHorizontalStyle, deviceHeight, deviceWidth } = useAppFrameDimensions(isWeb);
    const { top } = useSafeAreaInsets();
    const bubblePosition = useMemo(() => {
        const notificationBottom = notificationPosition.y +
            notificationPosition.height +
            (isAndroid ? top : 0);
        return {
            top: notificationBottom + rem(8),
        };
    }, [notificationPosition, top]);
    const arrowPosition = useMemo(() => {
        const screenCenter = deviceWidth / 2;
        return {
            left: screenCenter - BUBBLE_ARROW_WIDTH / 2,
        };
    }, [deviceWidth]);
    // Calculate highlight dimensions reactively
    const highlightDimensions = useMemo(() => {
        const dimensions = {
            x: notificationPosition.x + rem(16),
            y: isAndroid ? notificationPosition.y + top : notificationPosition.y,
            width: notificationPosition.width - rem(32),
            height: notificationPosition.height - rem(16),
        };
        return dimensions;
    }, [notificationPosition, top]);
    const borderRadius = rem(16);
    return (<View style={StyleSheet.absoluteFillObject} pointerEvents="auto">
      <Svg style={StyleSheet.absoluteFillObject} pointerEvents="none" key={`${deviceWidth}-${deviceHeight}-${highlightDimensions.x}-${highlightDimensions.y}`}>
        <Defs>
          <Mask id="mask" x="0" y="0">
            <Rect height={deviceHeight} width={deviceWidth} fill="#ffffff"/>
            <Rect x={highlightDimensions.x} y={highlightDimensions.y} width={highlightDimensions.width} height={highlightDimensions.height} rx={borderRadius} ry={borderRadius} fill="#000"/>
          </Mask>
        </Defs>
        <Rect height={deviceHeight} width={deviceWidth} fill="rgba(0, 0, 0, 0.80)" mask="url(#mask)"/>
      </Svg>
      <View style={[styles.bubbleContainer, bubblePosition]} pointerEvents="box-none">
        <WalkthroughBubbleArrow style={[styles.bubbleArrow, arrowPosition]}/>
        <View style={paddingHorizontalStyle} pointerEvents="auto">
          <NotificationsWalkthroughBubbleContent onPressDone={onDismiss}/>
        </View>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    bubbleContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
    },
    bubbleArrow: {
        position: 'absolute',
        top: rem(-10),
    },
});
export default NotificationsWalkthrough;
